// Cache the selector for better performance
const $imageBoxes = $(".big-cases-block .cases .item .image-box");

$imageBoxes.mouseover(function () {
    // Store the selected video elements
    const $videos = $(this).find("video");

    if ($videos.length > 0) {
        // Use 'this' context to play the first video
        $videos[0].play();
    }
});

$imageBoxes.mouseout(function () {
    const $videos = $(this).find("video");

    if ($videos.length > 0) {
        // Use 'this' context to pause the first video
        $videos[0].pause();
    }
});